import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Select from 'react-select';

import { uniqueToken, GpsBaseURL } from "../../api/DataApis";
import { getCorporateList } from "../../Apis/Setting";

function Add() {
  document.title = "Add Company Discount";
  const navigate = useNavigate();

  // States
  const [companyList, setCompanyList] = useState([]);
  const [corporateList, setCorporateList] = useState([]);

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedCorporate, setSelectedCorporate] = useState(null);
  const [discount, setDiscount] = useState("");

  // Fetch companies
  const fetchCompanies = async () => {
    try {
      const res = await axios.get(`${GpsBaseURL}/company`, {
        headers: { Authorization: `Bearer ${uniqueToken}` }
      });
      setCompanyList(res.data?.data || []);
    } catch (err) {
      console.error("Company fetch error:", err);
    }
  };

  // Fetch corporates
  const fetchCorporates = async () => {
    try {
      const res = await getCorporateList();
      setCorporateList(res.data || []);
    } catch (err) {
      console.error("Corporate fetch error:", err);
    }
  };

  useEffect(() => {
    fetchCompanies();
    fetchCorporates();
  }, []);

  const handleSubmit = async () => {
    if (!selectedCompany || !selectedCorporate || !discount) {
      Swal.fire("Error", "Please fill all fields", "warning");
      return;
    }

    Swal.fire({ title: 'Saving...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

    try {
      const res = await axios.put(
        `${GpsBaseURL}/company/${selectedCompany.value}/discount`,
        {
          corporate_id: selectedCorporate.value,
          discount: Number(discount),
        },
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.close();

      if (res.status === 200) {
        Swal.fire("Success", "Discount added successfully", "success");
        navigate("/company-discount-list");
      } else {
        Swal.fire("Error", res.data.message || "Failed to save", "error");
      }
    } catch (error) {
      Swal.close();
      console.error("Error saving discount:", error);
      Swal.fire("Error", error.response?.data?.message || "Server error", "error");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="portlet light bordered">
              <div className="portlet-title row">
                <div className="caption font-dark col-md-10">
                  <h4 className="caption-subject bold uppercase mx-3">Add Company Discount</h4>
                </div>
                <div className="caption font-dark col-md-2">
                  <button className="btn btn-success" onClick={() => navigate(-1)}>Back</button>
                </div>
              </div>
              <div className="portlet-body mx-3">
                <hr />
                <div className="row">
                  <div className="col-sm-12">
                    <form className="form-horizontal">
                      <div className="form-group row">
                        <label className="col-sm-2 control-label">Company</label>
                        <div className="col-sm-6">
                          <Select
                            options={companyList.map(c => ({ value: c._id, label: c.company_name }))}
                            value={selectedCompany}
                            onChange={setSelectedCompany}
                            isClearable
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-2 control-label">Corporate</label>
                        <div className="col-sm-6">
                          <Select
                            options={corporateList.map(c => ({ value: c._id, label: `${c.corporate_name} (${c.email})` }))}
                            value={selectedCorporate}
                            onChange={setSelectedCorporate}
                            isClearable
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <label className="col-sm-2 control-label">Discount (%)</label>
                        <div className="col-sm-6">
                          <input
                            type="number"
                            className="form-control"
                            value={discount}
                            onChange={(e) => setDiscount(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-offset-2 col-sm-8">
                          <button type="button" className="btn btn-success" onClick={handleSubmit}>
                            Add Discount
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
}

export default Add;
